import { isEmpty } from "lodash"
import React, { MouseEventHandler, useEffect, useState } from "react"
import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { SERVICE_TYPE } from "../../constants/constants"

const ValueAddedServiceModal = ({
    loading,
    show,
    setShow,
    valueAddedServiceDetails,
    setValueAddedServiceDetails,
    handleClose,
    handleSubmit,
    errors,
    setErrors
}: {
    loading: boolean
    show: string
    setShow: Function
    valueAddedServiceDetails: Record<string, any>
    setValueAddedServiceDetails: Function
    handleClose: Function
    handleSubmit: Function
    errors: Record<string, any>
    setErrors: Function
}) => {
    const { t } = useTranslation()
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        if (!isEmpty(errors)) {
            setErrors({})
        }
    }, [])

    useEffect(() => {
        if (
            (!valueAddedServiceDetails?.id &&
                (!valueAddedServiceDetails?.service ||
                    valueAddedServiceDetails?.service === "" ||
                    !valueAddedServiceDetails?.service_value ||
                    valueAddedServiceDetails?.service_value <= 0 ||
                    !valueAddedServiceDetails?.description ||
                    valueAddedServiceDetails?.description === "" ||
                    !valueAddedServiceDetails?.min_value ||
                    valueAddedServiceDetails?.min_value < 0)) ||
            (errors?.service_value && errors?.service_value !== "") ||
            (errors?.service && errors?.service !== "") ||
            (errors?.description && errors?.description !== "") ||
            (errors?.min_value && errors?.min_value !== "")
        ) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }
    }, [JSON.stringify(errors), JSON.stringify(valueAddedServiceDetails)])

    return (
        <Modal
            size={"lg"}
            show={show == "editOrCreateModal"}
            onHide={() => {
                setShow(false)
                setValueAddedServiceDetails(null)
            }}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {valueAddedServiceDetails?.id ? (
                        <>
                            {" "}
                            {t("Updating value added service rate of #")}&nbsp;
                            {valueAddedServiceDetails?.id}{" "}
                        </>
                    ) : (
                        <> {t("Create new value added service")} </>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="value-added-service-modal">
                <Row className="d-flex justify-content-around">
                    <Col lg={12}>
                        <Row className={"container"}>
                            <Col lg={12} className="mb-3">
                                <Form.Group>
                                    <Form.Label htmlFor="name">{t("Service Name")}</Form.Label>
                                    <Form.Control
                                        id="name"
                                        autoComplete="off"
                                        type="text"
                                        name={"service"}
                                        disabled={!!valueAddedServiceDetails?.id}
                                        value={valueAddedServiceDetails?.service || ""}
                                        onChange={(e: any) => {
                                            if (e.target.value !== "") {
                                                setErrors({ ...errors, service: "" })
                                            } else {
                                                setErrors({ ...errors, service: "Service name is required" })
                                            }
                                            setValueAddedServiceDetails({
                                                ...valueAddedServiceDetails,
                                                service: e.target.value
                                            })
                                        }}
                                        placeholder="Service Name"
                                        isInvalid={errors?.service && errors?.service !== ""}
                                    />
                                    {errors?.service && errors?.service !== "" && (
                                        <Form.Control.Feedback type="invalid">
                                            {t(`${errors?.service}`)}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col lg={12} className="mb-3">
                                <Form.Group>
                                    <Form.Label htmlFor="description">{t("Description")}</Form.Label>
                                    <Form.Control
                                        id="description"
                                        autoComplete="off"
                                        name={"description"}
                                        value={valueAddedServiceDetails?.description || ""}
                                        as="textarea"
                                        onChange={(e: any) => {
                                            if (e.target.value !== "") {
                                                setErrors({ ...errors, description: "" })
                                            } else {
                                                setErrors({
                                                    ...errors,
                                                    description: "Service description is required"
                                                })
                                            }
                                            setValueAddedServiceDetails({
                                                ...valueAddedServiceDetails,
                                                description: e.target.value
                                            })
                                        }}
                                        placeholder="Describe this service..."
                                        isInvalid={errors?.description && errors?.description !== ""}
                                    />
                                    {errors?.description && errors?.description !== "" && (
                                        <Form.Control.Feedback type="invalid">
                                            {t(`${errors?.description}`)}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col lg={6}>
                                <Form.Group>
                                    <Form.Label htmlFor="serviceValue">{t("Service Value")}</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            id="serviceValue"
                                            type="number"
                                            autoComplete="off"
                                            name={"service_value"}
                                            value={valueAddedServiceDetails?.service_value || 0}
                                            onChange={(e: any) => {
                                                if (parseFloat(e.target.value) > 0) {
                                                    setErrors({ ...errors, service_value: "" })
                                                } else {
                                                    setErrors({
                                                        ...errors,
                                                        service_value:
                                                            "Service value is required, and cannot be negative"
                                                    })
                                                }
                                                setValueAddedServiceDetails({
                                                    ...valueAddedServiceDetails,
                                                    service_value: parseFloat(e.target.value)
                                                })
                                            }}
                                            placeholder="Service Value"
                                            isInvalid={errors?.service_value && errors?.service_value !== ""}
                                        />
                                        {/* <InputGroup.Text
                                                className="tr-pointer"
                                                onClick={() => setValueAddedServiceDetails({
                                                    ...valueAddedServiceDetails,
                                                    service_type: valueAddedServiceDetails.service_type === SERVICE_TYPE["0"] ?
                                                        SERVICE_TYPE["1"]
                                                        :
                                                        SERVICE_TYPE["0"]
                                                })}
                                            >
                                                {valueAddedServiceDetails?.service_type === SERVICE_TYPE["0"] ? "$" : "%"}</InputGroup.Text> */}
                                        {errors?.service_value && errors?.service_value !== "" && (
                                            <Form.Control.Feedback type="invalid">
                                                {t(`${errors?.service_value}`)}
                                            </Form.Control.Feedback>
                                        )}
                                    </InputGroup>
                                    <Row>
                                        <Col lg={6}>
                                            <Form.Check
                                                type="radio"
                                                name="service_type"
                                                label={t("$")}
                                                onChange={() =>
                                                    setValueAddedServiceDetails({
                                                        ...valueAddedServiceDetails,
                                                        service_type: SERVICE_TYPE["0"]
                                                    })
                                                }
                                                required={true}
                                                checked={
                                                    valueAddedServiceDetails?.service_type === SERVICE_TYPE["0"]
                                                }
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Check
                                                type="radio"
                                                name="service_type"
                                                label={t("%")}
                                                onChange={() =>
                                                    setValueAddedServiceDetails({
                                                        ...valueAddedServiceDetails,
                                                        service_type: SERVICE_TYPE["1"]
                                                    })
                                                }
                                                required={true}
                                                checked={
                                                    valueAddedServiceDetails?.service_type === SERVICE_TYPE["1"]
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                            <Col lg={6}>
                                <Form.Group>
                                    <Form.Label htmlFor="minValue">{t("Minimum")}</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            id="minValue"
                                            type="number"
                                            autoComplete="off"
                                            name={"min_value"}
                                            value={valueAddedServiceDetails?.min_value || 0}
                                            minLength={12}
                                            onChange={(e: any) => {
                                                if (parseFloat(e.target.value) >= 0) {
                                                    setErrors({ ...errors, min_value: "" })
                                                } else {
                                                    setErrors({
                                                        ...errors,
                                                        min_value:
                                                            "Service minimum value is required, and cannot be negative"
                                                    })
                                                }
                                                setValueAddedServiceDetails({
                                                    ...valueAddedServiceDetails,
                                                    min_value: parseFloat(e.target.value)
                                                })
                                            }}
                                            placeholder="Minimum Value"
                                            isInvalid={errors?.min_value && errors?.min_value !== ""}
                                        />
                                        <InputGroup.Text>$</InputGroup.Text>
                                        {errors?.min_value && errors?.min_value !== "" && (
                                            <Form.Control.Feedback type="invalid">
                                                {t(`${errors?.min_value}`)}
                                            </Form.Control.Feedback>
                                        )}
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                    {t("Close")}
                </Button>

                <Button
                    onClick={() => {
                        handleSubmit(valueAddedServiceDetails)
                        handleClose()
                    }}
                    disabled={disabled}
                    className="btn btn-primary"
                    type="submit">
                    {loading ? (
                        <div className="spinner-border text-light" role="submit"></div>
                    ) : valueAddedServiceDetails?.id ? (
                        t("Update")
                    ) : (
                        t("Submit")
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ValueAddedServiceModal
